import React from "react";
import { MdOutlineEmail } from "react-icons/md";
import { CiPhone } from "react-icons/ci";
import { CiLocationOn } from "react-icons/ci";
import { useState } from "react";
import Message from "./message";
function Contact() {
  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append("access_key", "287684cd-9861-4f67-8a59-c92469774cfb");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();
    if (data.success) {
      console.log("Form Submitted Successfully");
      event.target.reset();
    } else {
      console.log("Error");
    }
    setright("0px");
  };
  const hundleCloseMessage = () => {
    setright("-250px");
    setemail(vide);
    setname(vide);
    setmessage(vide);
  };
  const [right, setright] = useState("-250px");
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [message, setmessage] = useState("");
  const vide = "";
  function changeWritingName(e) {
    setname(e.target.value);
  }
  function changeWritingEmail(e) {
    setemail(e.target.value);
  }
  function changeWritingMessage(e) {
    setmessage(e.target.value);
  }

  const infodata = [
    {
      svg: <MdOutlineEmail />,
      title: "Email",
      desc: "zakariaxhizzi@gmail.com",
    },
    {
      svg: <CiPhone />,
      title: "Phone",
      desc: "+213674042592",
    },
    {
      svg: <CiLocationOn />,
      title: "Location",
      desc: "Alger , Algerie",
    },
  ];
  return (
    <div id="contact">
      <section className="contact">
        <div className="top_section">
          <h5>Get In Touch</h5>
          <h2>Contact Me</h2>
        </div>
        <div className="container contact_container">
          <div>
            {infodata.map((i) => (
              <div className="contect_option">
                {i.svg}
                <h4>{i.title}</h4>
                <h5>{i.desc}</h5>
              </div>
            ))}
          </div>
          <form onSubmit={onSubmit}>
            <input
              type="text"
              placeholder="Your Name"
              name="name"
              value={name}
              onChange={changeWritingName}
              required
            />
            <input
              type="email"
              placeholder="Your Email"
              name="email"
              value={email}
              onChange={changeWritingEmail}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              value={message}
              rows={5}
              onChange={changeWritingMessage}
              required
            ></textarea>
            <button type="submit" className="btn btn-primary">
              Send Message
            </button>
          </form>
        </div>
      </section>
      <Message right={right} closeMenu={hundleCloseMessage} />
    </div>
  );
}

export default Contact;
